/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The CategoryCategories model module.
 * @module model/CategoryCategories
 * @version v1
 */
export class CategoryCategories {
  /**
   * Constructs a new <code>CategoryCategories</code>.
   * @alias module:model/CategoryCategories
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>CategoryCategories</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CategoryCategories} obj Optional instance to populate.
   * @return {module:model/CategoryCategories} The populated <code>CategoryCategories</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CategoryCategories();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('image_url'))
        obj.image_url = ApiClient.convertToType(data['image_url'], 'String');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
CategoryCategories.prototype.id = undefined;

/**
 * @member {String} image_url
 */
CategoryCategories.prototype.image_url = undefined;

/**
 * @member {String} name
 */
CategoryCategories.prototype.name = undefined;

